<template>
  <label @click="vSelected" class="company" :for="'company_'+PCSOC">
    <input type="radio" name="company" :id="'company_'+PCSOC" class="radio" ref="test" :value="PCSOC" />
    <label @click="checkRadio">{{PLIBSOC}}</label>
  </label>
</template>

<script>
export default {
  props: ["companyinfo", "selectedValue"],
  data() {
    return {
      PCSOC: "",
      PLIBSOC: "",
      PTUSER: "",
      selected: false
    };
  },
  created() {
    this.PLIBSOC = this.$props.companyinfo.PLIBSOC;
    this.PCSOC = this.$props.companyinfo.PCSOC;
    this.PTUSER = this.$props.companyinfo.PTUSER;
  },
  methods: {
    vSelected() {
      this.$parent.selectedValue = this.$props.companyinfo;
    },
    checkRadio() {
      this.$refs.test.checked = true;
    }
  }
};
</script>

<style scoped>
.company {
  border: solid 1px #e9e9e9;
  padding: 30px 30px;
  display: block;
}

.company:hover {
  cursor: pointer;
}
</style>